export function moneyFormat(amount) {
    const numberFormatted = new Intl.NumberFormat('en-US').format(amount);
    return '$' + numberFormatted;
}